<template>
    <div>

        <!-- FILTER START -->
        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="outerBox filterBox">
                <div class="row">
                    <div class="col-md-3">
                        <label>Location Type</label>
                        <Multiselect 
                          v-model="filter.location_type"
                          :options="options.location_type"
                          placeholder="All Location Types"
                        ></Multiselect>
                    </div>
                    <div class="col-md-3">
                        <label>Search</label>
                        <input type="text" class="form-control" v-model="filter.search" style="height: 41.5px;" placeholder="Search Loc Code / Name">
                    </div>
                    <div class="col-md-3 offset-md-3" style="display: flex; flex-direction: column-reverse; padding-top:20px">
                        <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-md-3">
                        <label>Code</label>
                        <Multiselect 
                          v-model="filter.code"
                          :options="options.code.map(x => x.codeMarket)"
                          :multiple="true"
                          placeholder="All Code"
                        ></Multiselect>
                    </div>
                </div> -->
            </div>
        </panel>
        <!-- FILTER END -->

		<h3 class="mt-2 mb-3">Location Settings</h3>

        <!-- :hide_column="['id', 'parent_code', 'dealer_type', 'karesidenan', 'address', 'city', 'email', 'phone_no', 'location', 'alias_code']" -->
        <vue-universal-table
            api_url="/api/setting/locations"
            :filter="filter"
            :buttons="vue_universal_table.buttons"
            :update="vue_universal_table.update"
            :special_buttons="['uploadFile','newVehicleType']"
            :fields="vue_universal_table.fields"
            :process_data="vue_universal_table.process_data"
            sort_by="loc_code"
            sort_order="ASC"
            @onNewVehicleType="modal.new = true"
            @onUploadFile="modal.upload = true"
            @onEdit="editLocation"
            @onDetail="infoLocation"
        ></vue-universal-table>

        <cu-location
            v-if="modal.new || modal.edit"
            :data="modal.edit ? modal.editData : null"
            @refreshData="vue_universal_table.update++;"
            @closeModal="modal.new = false; modal.edit = false;"
        ></cu-location>


        <ModalUpload 
            v-if="modal.upload"
            @closeModal="modal.upload = false"
            @onFinish="vue_universal_table.update++"
        />

        <location-info
            v-if="modal.info"
            :data="modal.infoData"
            @closeModal="modal.info = false"
        ></location-info>

    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    import cuLocation from './children/CULocation'
    import ModalUpload from './children/ModalUpload.vue'
    import locationInfo from './children/locationInfo.vue'

    export default {
        data () {
            return {
                mobile : this.isMobile(),
                modal : {
                    new : false,
                    edit : false,
                    editData : null,
                    upload : false,
                    info : false,
                    infoData : null,
                },
                filter : {
                    location_type : null,
                    search : ''
                },
                options : {
                    location_type : ['MAINDEALER', 'AHASS', 'DEALER']
                },
                vue_universal_table : {
                    fields : [
                        {title:'Region Code', variable:'region_code'},
                        {title:'Loc Code', variable:'loc_code'},
                        {title:'Name', variable:'name'},
                        {title:'Type', variable:'type'},
                        {title:'Status', variable:'is_active', style_condition : {
                            'Inactive' : 'color: red; font-weight: bold',
                            'Active' : 'color: green; font-weight: bold'
                        }},
                    ],
                    buttons : [
                        {title:'Detail', class:'btn-outline-info fas fa-info'},
                        {title:'Edit', class:'btn-outline-primary fas fa-edit'}
                    ],
                    update : 0,
                    process_data : `
                        for (var i in data) data[i].is_active = data[i].is_active ? 'Active' : 'Inactive'
                    `
                },
            }
        },
        components : {
            Multiselect,
            cuLocation,
            ModalUpload,
            locationInfo
        },
        mounted () {
            // console.log(this.$store.getters.getSimpleCodeMarket());
        },
        methods : {
            editLocation (data) {
                this.modal.editData = JSON.parse(data);
                this.modal.edit = true;
            },
            infoLocation (data) {
                this.modal.infoData = JSON.parse(data);
                this.modal.info = true;
            },
        }
    }
</script>

<style scoped>

</style>